import { Space, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { getBankAccountTotalAmount } from '@features/bankAccounts/utils/getBankAccountTotalAmount'

import { useLocale } from '../../../../../../../../hooks/useLocale'

interface AccountsBalanceProps {
  amount: number
  currency: string
}

export const AccountsBalance = ({ amount, currency }: AccountsBalanceProps): ReactElement => {
  const { t } = useTranslation()
  const { code } = useLocale()

  const formattedAmount = getBankAccountTotalAmount({ amount, currency, locale: code })
  const isNegativeAmount = amount < 0

  return (
    <>
      <Text weight="bold">{t('bank.accounts.total_amount_label')}</Text>
      <Text variant="h1" weight="bold" colorVariant={isNegativeAmount ? 'danger' : 'primary'}>
        {formattedAmount}
      </Text>
      <Space size="s32" />
    </>
  )
}
